module.exports = __webpack_public_path__ + "static/img/9.bba4b85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/sp/9.png
// module id = 73Wd
// module chunks = 0